import React from 'react';

function WishlistCardSkeleton() {
  return (
    <div className="wishlist-skeleton-card">
      <div className="skeleton-block wishlist-skeleton-card-tag" />
      <div className="skeleton-block wishlist-skeleton-card-visual" />
      <div className="wishlist-skeleton-card-footer">
        <div className="skeleton-lines">
          <div className="skeleton-block" style={{ height: 14, width: '75%' }} />
          <div className="skeleton-block" style={{ height: 10, width: '50%' }} />
        </div>
        <div className="skeleton-block" style={{ height: 32, width: '100%' }} />
      </div>
    </div>
  );
}

export default function WishlistSkeleton() {
  return (
    <div className="page-skeleton wishlist-skeleton">
      <div className="skeleton-card wishlist-skeleton-stats">
        {[0, 1, 2, 3].map((index) => (
          <div key={index} className="wishlist-skeleton-stat">
            <div className="skeleton-circle" style={{ width: 24, height: 24 }} />
            <div className="skeleton-block" style={{ height: 28, width: 32 }} />
            <div className="skeleton-block" style={{ height: 10, width: 56 }} />
          </div>
        ))}
      </div>

      <div className="wishlist-skeleton-toolbar">
        <div className="wishlist-skeleton-filters">
          {[72, 64, 56, 80, 68].map((width, index) => (
            <div key={index} className="skeleton-block" style={{ height: 38, width }} />
          ))}
        </div>
        <div className="skeleton-block" style={{ height: 38, width: 140 }} />
      </div>

      <div className="wishlist-skeleton-grid">
        {[0, 1, 2, 3, 4, 5].map((index) => (
          <WishlistCardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
}
